import React from 'react';

const Loader = ({ fullScreen = false, size = 'lg', className = '' }) => {
  const sizeClasses = {
    sm: 'h-6 w-6 border-2',
    md: 'h-9 w-9 border-2',
    lg: 'h-12 w-12 border-4',
    xl: 'h-16 w-16 border-4',
  };

  const spinner = (
    <div className="relative flex items-center justify-center">
      {/* Background glow shadow effect */}
      <div className={`absolute rounded-full bg-[#fe2c55]/20 blur-md ${sizeClasses[size]}`}></div>
      {/* Outer spinning ring with gradient */}
      <div 
        className={`animate-spin rounded-full border-t-[#fe2c55] border-b-[#25f4ee] border-l-transparent border-r-transparent ${sizeClasses[size]} ${className}`}
      ></div>
    </div>
  );

  if (fullScreen) {
    return (
      <div className="flex flex-col gap-4 justify-center items-center min-h-screen w-full bg-[#06070a]/80 backdrop-blur-lg z-50 fixed inset-0">
        {spinner}
        <span className="text-[10px] tracking-[0.2em] font-black uppercase text-white/40 animate-pulse">
          Loading Reelkart...
        </span>
      </div>
    );
  }

  return spinner;
};

export default Loader;